// extracted by mini-css-extract-plugin
export default {"dtcategory":"AppSidebarGroups_dtcategory__6if0L","selectedsubItem":"AppSidebarGroups_selectedsubItem__CPYNh"};